"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// build/index.ts
var build_exports = {};
__export(build_exports, {
  default: () => AnalyticsSDK
});
module.exports = __toCommonJS(build_exports);
var import_mixpanel_browser = __toESM(require("mixpanel-browser"));
var AnalyticsSDK = class {
  constructor(mixpanelToken, client) {
    import_mixpanel_browser.default.init(mixpanelToken, {
      track_pageview: true,
      api_host: "https://api-eu.mixpanel.com"
    });
    import_mixpanel_browser.default.register({ client });
  }
  identify(userId, accountId, providerId) {
    import_mixpanel_browser.default.identify(userId);
    import_mixpanel_browser.default.people.set({ accountId, providerId });
  }
  reset() {
    import_mixpanel_browser.default.reset();
  }
  track(eventName, payload) {
    import_mixpanel_browser.default.track(eventName, payload);
  }
  trackSupport(payload) {
    return this.track(`event.support`, payload);
  }
  trackJourney(payload) {
    return this.track(`event.journey`, payload);
  }
  trackJourneyStep(payload) {
    return this.track(`event.journey-step`, payload);
  }
  trackClick(payload) {
    return this.track(`event.click`, payload);
  }
  trackImpression(payload) {
    return this.track(`event.impression`, payload);
  }
  trackVisit(payload) {
    return this.track(`event.visit`, payload);
  }
};
//# sourceMappingURL=index.js.map